inicio.component('inicio.inicioComponent', {
    templateUrl: 'inicio/inicio.html',
    controller: 'inicio.inicioController',
    controllerAs: '$ctrl'
});

inicio.controller('inicio.inicioController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', function($rootScope, $scope, $text, $state, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.areaMembros = {};
    $ctrl.acessoExtraModal=false;

    const _getAreaMembros=(idArea)=>{

        $fb.db.get(`cad_areaMembros/${idArea}`).then(doc=>{
            $ctrl.areaMembros = doc;
            $state.params.showGlobalLoading = false;

        }).catch(e=>{
            console.log(e);
        });
    };

    const _getHasAcessoExtra=()=>{
       
        $fb.functions.invoke('fatura_hasAcessoExtra').then((res)=>{
            $ctrl.acessoExtra = res;
        });
    };

    $ctrl.setAcessoExtraModal=(value)=>{
        $ctrl.acessoExtraModal = value;
    };

    $ctrl.enviarAcessoExtra=(email)=>{
        $ctrl.invalidEmail = false;
        $ctrl.loading = true;

        if(!email || !email.length){
            $ctrl.invalidEmail = true;
            $ctrl.loading = false;
            return;
        }

        $fb.functions.invoke('fatura_sendAcesso', {email: email}).then(()=>{
            $state.reload();
        });

    };

    $ctrl.goLink=(link)=>{
        if(!link){
            return;
        }

        window.open(link, '_blank');

    };

    $ctrl.$onInit = () => {
        $rootScope.idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _getHasAcessoExtra();
        
        _getAreaMembros($rootScope.idAreaMembros);
        $scope.isDesktop = $rootScope.isDesktop;
    };
    
}]);